// https://codepen.io/souporserious/pen/XJQLEb
import React, { useRef, useEffect, useState } from 'react';
import { cleanFieldProps, parseClasses, isColorBright, RGB_2_HEX } from '../../lib/ep.js';

import FieldWrapper from './FieldWrapper.js';

const SwipeSlider = (props) => {
	const [ main_color, setMainColor ] = useState(props?.color ?? 'rgba(60, 70, 200, 1)');

	useEffect(() => {
		setMainColor(props?.color ?? 'rgba(60, 70, 200, 1)');
	}, [ props.color ]);

	const disabled = props?.disabled ?? false;

	const retraction_speed = 5;
	const animation_timer = useRef();

	const resetSliderAnimation = () => {
		if(document.querySelector('.swiper').value > 0) {
			animation_timer.current = window.requestAnimationFrame(resetSliderAnimation);
		} else {
			window.cancelAnimationFrame(animation_timer.current);
		}

		const new_value = Math.max(0, document.querySelector('.swiper').value - retraction_speed);
		document.querySelector('.swiper').value = new_value;
		moveFiller();
	};

	const unlockSlider = () => {
		if(props.onSuccess != undefined) props.onSuccess();
	};

	const toggleEnd = () => {
		if(document.querySelector('.swiper').value > 95) {
			unlockSlider();
			return;
		}

		if(props.onReset != undefined) props.onReset();
		animation_timer.current = window.requestAnimationFrame(resetSliderAnimation);
	};

	const moveFiller = () => {
		document.querySelector('.swiped_area').style.right = `calc(${100 - document.querySelector('.swiper').value}% + ${document.querySelector('.swiper').value / 100 - 1} * var(--thumb-size))`;
	};

	const change = () => {
		moveFiller();
	};

	const reset = () => {
		window.cancelAnimationFrame(animation_timer.current);
	};

	const wrapper_props = cleanFieldProps(props);
	wrapper_props.label = null;

	if(!isColorBright(RGB_2_HEX(main_color))) {
		const field_classes = wrapper_props?._class ?? {};
		const field_classes_other = (field_classes?.other ?? '').split(" ");
		field_classes_other.push('white_icon');
		field_classes.other = field_classes_other.join(" ");
		wrapper_props._class = field_classes;
	}

	let classname = props?.classname ?? 'input swiper';
	classname = parseClasses(classname, props._class, 'swiper');

	const field_class = ['common_form_item'];
	if(disabled) field_class.push('disabledField disabledItem');

	return (
		<FieldWrapper type='swipe' {...wrapper_props}>
			<div class="swipe_bg">{props.children}</div>

			<div
				class="swiped_area"
				style={{
					right:'calc(100% - 1 * var(--thumb-size))',
				}}
			/>

			<input
				type="range"
				class="swiper"
				defaultValue={0}
				onMouseDown={reset}
				onTouchStart={reset}
				onMouseUp={toggleEnd}
				onTouchEnd={toggleEnd}
				onChange={change}
				min={0}
				max={100}
			/>
		</FieldWrapper>
	);
}

export default SwipeSlider;